var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./TabPanel.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3d271ce6\"}!../../vue-loader/lib/selector?type=template&index=0!./TabPanel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/primevue/tabpanel/TabPanel.vue
// module id = 1993
// module chunks = 0